export default __webpack_public_path__ + "static/media/0023.0fa70a2f.WAV";